export const API_BASE_URI = process.env.REACT_APP_API_BASE_URI || '';

export const LOCAL_STORE_PREFIX = 'showcase.';

export const LOGIN_URL = '/auth/login';
export const REFRESH_URL = '/auth/refresh_tokens';

export const PHONE_LENGTH = 12;
export const TIN_LENGTH = 10;
export const TIN_IE_LENGTH = 12;
export const KPP_LENGTH = 9;
export const OGRN_LENGTH = 13;
export const OGRN_IE_LENGTH = 15;

export const CAMPAIGNS_STATUSES = {
	DELAYED_START: 'DELAYED_START',
	FINISHED: 'FINISHED',
	PAUSED: 'PAUSED',
	RUNNING: 'RUNNING',
	STOPPED: 'STOPPED',
	WAITING: 'WAITING',
};
export const CAMPAIGNS_TYPES = {
	WEB: 'WEB',
	SUBSCRIPTION: 'SUBSCRIPTION',
	GEO: 'GEO',
};
export const CAMPAIGNS_BUDGET = {
	DEFAULT: 'DEFAULT',
	MINIMAL: 'MINIMAL',
	OPTIMAL: 'OPTIMAL',
	MAXIMAL: 'MAXIMAL',
	WEB_MINIMAL: 'WEB_MINIMAL',
	WEB_OPTIMAL: 'WEB_OPTIMAL',
	WEB_MAXIMAL: 'WEB_MAXIMAL',
};
export const CAMPAIGNS_PERIOD = {
	90: '90',
	180: '180',
	360: '360',
};

export const YANDEX_METRIKA = 89254388;
